import React from "react";
import "./about.css";

const About = () => (
  <section id="about" className="about">
    <div className="about__inner">
      <div className="about__content">
        <h2 className="about__title">What is the Guide about?</h2>
        <p className="about__description">
          The EHDS Guide supports you in implementing the European Health Data Space. 
          It helps you understand the necessary steps, manage your data transparently and securely, 
          and assess your digital maturity in handling health data. Whether you want to provide data, 
          use it, or meet regulatory requirements, here you will find concrete guidance and the right tools for your needs. 
          After registering, set up your profile, answer the short questionnaire, 
          and immediately receive a personalized assessment—including specific recommendations for action to help you take targeted next steps.
        </p>
      </div>
    </div>
  </section>
);

export default About;
